import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "range",
      description: "数据范围（索引值），形如[${min}, ${max}]的数组",
      type: "Array",
      required: "是"
    },
    {
      prop: "value",
      description: "绑定值，为形如[${min}, ${max}]的数组，可指定初值",
      type: "Array",
      required: "是"
    },
    {
      prop: "label",
      description: "绑定标签，再拖动状态下显示对应索引值的标签",
      type: "Array",
      required: "是"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
